import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  key: 0,
  class: "header-subtitle"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-row row" }
const _hoisted_7 = { class: "form-field col-12 col-md-3" }
const _hoisted_8 = { class: "readonly-box" }
const _hoisted_9 = { class: "form-field col-12 col-md-3" }
const _hoisted_10 = { class: "readonly-box" }
const _hoisted_11 = { class: "form-field col-12 col-md-6" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = { class: "history-table" }
const _hoisted_16 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_17 = {
  class: "col-call-no",
  "data-label": "Call No."
}
const _hoisted_18 = {
  class: "col-user",
  "data-label": "User"
}
const _hoisted_19 = {
  class: "col-time",
  "data-label": "Time"
}
const _hoisted_20 = {
  class: "col-status",
  "data-label": "Call Status"
}
const _hoisted_21 = {
  class: "col-comments",
  "data-label": "Comments"
}
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = ["disabled"]

import { computed, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChaseupCallsModal',
  props: {
    baseUrl: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const isModalVisible = ref(false)
const jobId = ref(0)
const jobLabel = ref('')
const chaseupCalls = ref<any[]>([])
const reversedChaseupCalls = computed(() =>
  chaseupCalls.value.map((call, index) => ({ ...call, callNo: index + 1 })).reverse()
)
const chaseupCallStatuses = ref<any[]>([])
const selectedStatusId = ref<number>(0)
const comment = ref('')
const isSaving = ref(false)
const errorMessage = ref('')
const currentDate = ref('')
const currentTime = ref('')

const emit = __emit

function refreshCurrentDateTime() {
  const now = new Date()
  currentDate.value = now.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\//g, '-')
  currentTime.value = now.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  })
}

function loadChaseupCallStatuses() {
  const stored = localStorage.getItem('chaseupCallStatuses')
  if (stored) {
    try {
      chaseupCallStatuses.value = JSON.parse(stored)
    } catch (e) {
      console.error('Failed to parse chaseupCallStatuses:', e)
    }
  }
  if (chaseupCallStatuses.value.length > 0) {
    selectedStatusId.value = chaseupCallStatuses.value[0].id
  }
}

function formatTime(dateString: string): string {
  if (!dateString) return 'N/A'
  try {
    const date = new Date(dateString)
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch {
    return dateString
  }
}

function openForJob(id: number, calls: any[], job?: any) {
  jobId.value = id
  chaseupCalls.value = Array.isArray(calls) ? calls : []
  jobLabel.value = job ? `${job.securityOfficerInfo || ''} - ${job.siteInfo || ''}` : ''
  errorMessage.value = ''
  comment.value = ''
  refreshCurrentDateTime()
  loadChaseupCallStatuses()
  isModalVisible.value = true
  document.body.classList.add('modal-open')
}

function closeModal() {
  isModalVisible.value = false
  document.body.classList.remove('modal-open')
  emit('close')
}

async function addChaseupCall() {
  errorMessage.value = ''
  isSaving.value = true
  try {
    const res = await fetch(props.baseUrl + 'ChaseupCalls/AddChaseupCall', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        JobId: jobId.value,
        ChaseupCallStatusId: selectedStatusId.value,
        Comment: comment.value
      })
    })

    const result = await res.json()

    if (result.chaseupCall) {
      chaseupCalls.value.push(result.chaseupCall)
      comment.value = ''
      if (chaseupCallStatuses.value.length > 0) {
        selectedStatusId.value = chaseupCallStatuses.value[0].id
      }
    } else {
      errorMessage.value = result.responseMessage || 'Failed to save chaseup call.'
    }
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Failed to save chaseup call.'
  } finally {
    isSaving.value = false
  }
}

__expose({ openForJob, closeModal })

return (_ctx: any,_cache: any) => {
  return (isModalVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-backdrop",
          onClick: closeModal
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Chaseup Calls", -1)),
              (jobLabel.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(jobLabel.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", { onClick: closeModal }, "×")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Current Date", -1)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(currentDate.value), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", null, "Current Time", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(currentTime.value), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("label", null, "Call Status", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStatusId).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chaseupCallStatuses.value, (status) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: status.id,
                      value: status.id
                    }, _toDisplayString(status.name), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedStatusId.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("label", null, "Chaseup Comment", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
                rows: "3"
              }, null, 512), [
                [_vModelText, comment.value]
              ])
            ]),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"table-header\" data-v-745a431c><div class=\"col-call-no\" data-v-745a431c>Call No.</div><div class=\"col-user\" data-v-745a431c>User</div><div class=\"col-time\" data-v-745a431c>Time</div><div class=\"col-status\" data-v-745a431c>Call Status</div><div class=\"col-comments\" data-v-745a431c>Comments</div></div>", 1)),
              (chaseupCalls.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "No calls found"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reversedChaseupCalls.value, (call) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: call.id,
                  class: "table-row"
                }, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(call.callNo), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(call.createdByOperatorName), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(formatTime(call.callTime)), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(call.statusName), 1),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(call.comment), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              class: "btn-add",
              disabled: isSaving.value,
              onClick: addChaseupCall
            }, "ADD", 8, _hoisted_23),
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: closeModal
            }, "CLOSE")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})